import React, { useEffect, useState } from "react";
import { getValueAmountOwed } from "utils/buro";
import { pad } from "utils/getLocalDateTime";
import { Button } from "./wrapper";
import { differenceInDays, format } from "date-fns";
import { months } from "../../../utils/getLocalDateTime";
import FileSaver from "file-saver";
import { calReportAging } from "utils/calReportAging";
import { getFilterLoanBuro } from "components/BuroBug/BuroMainTwo";

const iconv = require("iconv-lite");

const getBirthDay = (birthDay) => {
  const splitBirthDate = birthDay.split("/");
  const day = splitBirthDate[0];
  const month = splitBirthDate[1];
  const year = splitBirthDate[2] - 543;
  return `${year}-${pad(month)}-${pad(day)}`;
};

const getWorkingCondition = (careertype) => {
  // ["อาชีพ", "พนักงานเอกชน", "ข้าราชการ/รัฐวิสาหกิจ", "ลูกจ้าง", "คนขับแท๊กซี่/มอเตอร์ไซค์รับจ้าง ", "อาชีพอิสระ/ฟรีแลนซ์ ", "เจ้าของกิจการ", "ค้าขาย"]

  if (
    careertype === "พนักงานเอกชน" ||
    careertype === "ลูกจ้าง" ||
    !careertype
  ) {
    return "0787300015";
  } else if (careertype === "ข้าราชการ/รัฐวิสาหกิจ") {
    return "0787300005";
  } else if (
    careertype === "คนขับแท๊กซี่/มอเตอร์ไซค์รับจ้าง " ||
    careertype === "อาชีพอิสระ/ฟรีแลนซ์ " ||
    careertype === "เจ้าของกิจการ" ||
    careertype === "ค้าขาย"
  ) {
    return "0787300019";
  } else return "0787300015";
};

const getSector = (careertype) => {
  if (
    careertype === "พนักงานเอกชน" ||
    careertype === "ลูกจ้าง" ||
    !careertype
  ) {
    return "0787500010";
  } else if (careertype === "ข้าราชการ/รัฐวิสาหกิจ") {
    return "0787500011";
  } else if (careertype === "คนขับแท๊กซี่/มอเตอร์ไซค์รับจ้าง ") {
    return "0787500008";
  } else if (careertype === "อาชีพอิสระ/ฟรีแลนซ์ ") {
    return "0787500010";
  } else if (careertype === "เจ้าของกิจการ" || careertype === "ค้าขาย") {
    return "0787500004";
  } else return "0787500010";
};

export const getObjectPLC = (itemLoan, buroDate, isClearStr = false) => {
  const diffOverdueDate = differenceInDays(
    new Date(itemLoan.overdue_date),
    new Date(buroDate)
  );

  const endOfDate = new Date(buroDate);
  // endOfDate.setDate(months[endOfDate.getMonth()].days);

  let อาชีพของผู้กู้ = `${itemLoan.careertype}`;

  if (String(itemLoan?.careertype)?.search("ข้าราชการ/รัฐวิสาหกิจ") !== -1) {
    อาชีพของผู้กู้ = `ข้าราชการ`;
  }

  if (!itemLoan.careertype) {
    อาชีพของผู้กู้ = `พนักงานเอกชน`;
  }

  let valueLoanObj = {
    รหัสสถาบัน: `"0105563138266"`,
    งวดข้อมูล: `"${format(new Date(endOfDate), "yyyy-MM-dd")}"`,
    รหัสของผู้กู้: `"${itemLoan?.citizenid}"`,
    ประเภทรหัสของผู้กู้: `"324001"`,
    ชื่อผู้กู้: `"${itemLoan?.fullname}"`,
    วันเกิดของผู้กู้: `"${getBirthDay(itemLoan?.birthdateTh)}"`,
    ภาวะการทำงาน: `"${getWorkingCondition(itemLoan?.careertype)}"`,
    อาชีพของผู้กู้: `"0787400112"`,
    อาชีพของผู้กู้อื่น: `"${อาชีพของผู้กู้}"`,
    ประเภทธุรกิจของกิจการที่ผู้กู้ทำงาน: `"${getSector(itemLoan?.careertype)}"`,
    การพิจารณารายได้รวมของผู้บริโภค: `"0760900001"`,
    รายได้: `"${parseInt(itemLoan.income)}"`,
    เลขที่สัญญา: `"${itemLoan.loan_kbank_id}"`,
    วันที่เริ่มสัญญา: `"${format(
      new Date(itemLoan.requestTime),
      "yyyy-MM-dd"
    )}"`,
    วันที่สิ้นสุดสัญญา: `"${itemLoan.endDate}"`,
    ประเภทสินเชื่อ: `"018022"`,
    วัตถุประสงค์การกู้: itemLoan?.type === "ธุรกิจ" ? `"012029"` : `"012001"`,
    วงเงินสินเชื่อ: `"${itemLoan.requestamount}"`,
    "อัตราดอกเบี้ย เบี้ยปรับ ค่าปรับ ค่าบริการ ค่าธรรมเนียมใด ๆ": `"${itemLoan?.loanInterest?.value}"`,
    หลักประกัน: `"0"`,
    ประเภทรถ: `""`,
    มูลค่ารถ: `""`,
    ประเภทสินเชื่อภายใต้การกำกับ:
      itemLoan.type === "ธุรกิจ" ? `"0786700002"` : `"0786700001"`,
    สินเชื่อดิจิทัล: `"0"`,
  };

  if (isClearStr) {
    Object.keys(valueLoanObj).forEach((key) => {
      valueLoanObj[key] = String(valueLoanObj[key])?.replaceAll(/\"/g, "");
    });
  }

  return valueLoanObj;
};

export const headerStr = `"รหัสสถาบัน"|"งวดข้อมูล"|"รหัสของผู้กู้"|"ประเภทรหัสของผู้กู้"|"ชื่อผู้กู้"|"วันเกิดของผู้กู้"|"ภาวะการทำงาน"|"อาชีพของผู้กู้"|"อาชีพของผู้กู้ กรณี อื่น ๆ"|"ประเภทธุรกิจของกิจการที่ผู้กู้ทำงาน"|"การพิจารณารายได้รวมของผู้บริโภค / การพิจารณาวงเงินสินเชื่อ"|"รายได้"|"เลขที่สัญญา"|"วันที่เริ่มสัญญา"|"วันที่สิ้นสุดสัญญา"|"ประเภทสินเชื่อ"|"วัตถุประสงค์การกู้"|"วงเงินสินเชื่อ"|"อัตราดอกเบี้ย เบี้ยปรับ ค่าปรับ ค่าบริการ ค่าธรรมเนียมใด ๆ"|"หลักประกัน"|"ประเภทรถ"|"มูลค่ารถ"|"ประเภทสินเชื่อภายใต้การกำกับ"|"สินเชื่อดิจิทัล"`;

function ReportBotPLC({ loan = [], buroDate = new Date(), interest }) {
  const [loading, setLoading] = useState(false);
  const [dataCsv, setDataCsv] = useState();
  const [error, setError] = useState();
  const [countExport, setCountExport] = useState(0);

  useEffect(() => {
    if (dataCsv) {
      const filename = `REPORT-BOT-PLC-${format(
        new Date(buroDate),
        "yyyy-MM"
      )}.csv`;
      const buffer = iconv.encode(dataCsv, "utf-8");
      const buroBlob = new Blob([buffer]);
      FileSaver.saveAs(buroBlob, filename);
    }
  }, [dataCsv]);

  const onClickReportBotPLC = async () => {
    try {
      setLoading(true);

      let { dataPrinciple: newLoans } = calReportAging(
        loan,
        new Date(buroDate)
      );

      // newLoans = getFilterLoanBuro(newLoans, buroDate, interest);

      let bodyStr = ``;
      let index = 0;
      for (const itemLoan of newLoans) {
        if (index >= newLoans.length) {
          break;
        }
        const valuePlo = getObjectPLC(itemLoan, buroDate);
        bodyStr += `${Object.values(valuePlo).join("|")}\n`;
        index++;
      }
      setDataCsv(`${headerStr}\n${bodyStr}`);
      setCountExport(index);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex">
      <Button
        onClick={onClickReportBotPLC}
        loading={loading}
        disabled={loading || !loan.length}
        color="emerald"
      >
        {countExport > 0 && countExport} Report Bot PLC
      </Button>
    </div>
  );
}

export default ReportBotPLC;
